import { Box, IconButton, Grid } from '@mui/material';
import { HighlightOffTwoTone } from '@mui/icons-material';
import { FormattedMessage } from 'react-intl';

import { Header, H3 } from './ControlsStyle';

export interface PreviewProps {
    onClose?: () => void;
    itemId?: number | string;
    question?: string;
    checktype?: boolean;
    // previewType?: 'question' | 'collection';
    previewType: 'question' | 'collection' | string;
}

const Preview = (props: PreviewProps) => {
    const { previewType, itemId, onClose, question, checktype } = props;

    const serverUrl = process.env.REACT_APP_LMS_URL || 'http://localhost:3000';
    // const containerTypeId = question && checktype ? 1 : !question && checktype ? 4 : 1;
    let containerTypeId;

    if (question && checktype) {
        containerTypeId = 1;
    } else if (!question && checktype) {
        containerTypeId = 4;
    } else {
        containerTypeId = 1;
    }

    const previewPath =
        previewType === 'collection'
            ? `/preview/QuestionPages?container_type_id=1&collection_id=${itemId}`
            : `/preview/QuestionPages?container_type_id=${containerTypeId}&question_id=${itemId}`;

    return (
        <>
            <Box sx={{ width: '70vw', height: '90vh', padding: 3.75, overflow: 'hidden' }}>
                <Header>
                    <H3 variant="h3">
                        <FormattedMessage id="Preview" defaultMessage="Preview" />
                    </H3>
                    <IconButton onClick={onClose}>
                        <HighlightOffTwoTone sx={{ height: '20px', width: '20px' }} />
                    </IconButton>
                </Header>
                <Grid container>
                    <Grid container item justifyContent="center" xs={12} sx={{ margin: '10px 0px 15px 0px' }}>
                        <iframe
                            src={`${serverUrl}${previewPath}`}
                            height="700"
                            width={previewType === 'collection' ? '1200' : '950'}
                            title="preview"
                            style={{
                                borderRadius: '0.7rem',
                                border: 'none',
                                boxShadow: `0px 1px 3px 0px rgba(0, 0, 0, 0.12), 0px 1px 1px 0px rgba(0, 0, 0, 0.14), 0px 2px 1px -1px rgba(0, 0, 0, 0.20)`
                            }}
                        />
                    </Grid>
                </Grid>
            </Box>
        </>
    );
};

export default Preview;
